import { PublicKey, SystemProgram, TransactionMessage, VersionedTransaction, } from '@solana/web3.js';
import bs58 from 'bs58';
export const JITO_FEE = 500000;
const jitoTipAccounts = [
    'Cw8CFyM9FkoMi7K7Crf6HNQqf4uEMzpKw6QNghXLvLkY',
    'DttWaMuVvTiduZRnguLF7jNxTgiMBZ1hyAumKUiL2KRL',
    '96gYZGLnJYVFmbjzopPSU6QiEV5fGqZNyN9nmNhvrZU5',
    '3AVi9Tg9Uo68tJfuvoKvqKNWKkC5wPdSSdeBnizKZ6jT',
    'HFqU5x63VTqvQss8hp11i4wVV8bD44PvwucfZ2bU7gRe',
    'ADaUMid9yfUytqMBgopwjb2DTLSokTSzL1zt6iGPaS49',
    'ADuUkR4vqLUMWXxW9gh6D6L8pMSawimctcNZ5pGwDcEt',
    'DfXygSm4jCyNCybVYYK6DwvWqjKee8pbDmJGcLWNDXjh',
];
const getRandomValidatorKey = () => {
    const randomValidator = jitoTipAccounts[Math.floor(Math.random() * jitoTipAccounts.length)];
    return new PublicKey(randomValidator);
};
export const bundle = async (txs, keypair, connection, priorityFee) => {
    var _a, _b;
    const abortController = new AbortController();
    console.log('executing order priority fee', priorityFee);
    try {
        const txNum = Math.ceil(txs.length / 3);
        let successNum = 0;
        const results = [];
        for (let i = 0; i < txNum; i++) {
            const upperIndex = (i + 1) * 3;
            const downIndex = i * 3;
            const newTxs = [];
            for (let j = downIndex; j < upperIndex; j++) {
                if (txs[j])
                    newTxs.push(txs[j]);
            }
            let tip = priorityFee ? priorityFee : JITO_FEE;
            let success = await bull_dozer(newTxs, keypair, connection, abortController.signal, tip);
            const { success: successValue, error, signatures, links } = success;
            console.log('successfully finished bulldozer', success);
            if (success && successValue > 0)
                successNum += 1;
            results.push(success);
        }
        if (successNum == 0) {
            return {
                error: 'No successful responses received from Jito',
                note: 'jito bundle error',
                network: 1399811149,
                status: 'error',
                errorTags: 'LIT, RUN_ONCE, JITO_BUNDLE - signAndSendSolanaJito',
            };
        }
        const successResults = (_b = (_a = results === null || results === void 0 ? void 0 : results[0]) === null || _a === void 0 ? void 0 : _a.signatures) === null || _b === void 0 ? void 0 : _b.map((signature) => {
            var _a;
            return {
                status: 'success',
                hash: signature,
                network: 1399811149,
                explorerUrl: `https://solscan.io/tx/${signature}`,
                bundleId: (_a = results === null || results === void 0 ? void 0 : results[0]) === null || _a === void 0 ? void 0 : _a.bundleId,
            };
        });
        if (!successResults || successResults.length == 0) {
            return {
                error: 'Executing Order SOLANA No successful responses received from Jito - transactions failed',
                note: 'jito bundle error',
                network: 1399811149,
                status: 'error',
            };
        }
        return successResults;
    }
    catch (error) {
        console.log('Executing Order SOLANA jito bundle error', error.message);
        return {
            error: error.message.slice(0, 400),
            note: 'jito bundle error',
            network: 1399811149,
        };
    }
    finally {
        abortController.abort();
    }
};
export const bull_dozer = async (txs, payer, connection, abortSignal, priorityFee) => {
    var _a;
    try {
        const jitoFeeWallet = getRandomValidatorKey();
        const latestBlockhash = await connection.getLatestBlockhash('confirmed');
        const jitTipTxFeeMessage = new TransactionMessage({
            payerKey: payer.publicKey,
            recentBlockhash: latestBlockhash.blockhash,
            instructions: [
                SystemProgram.transfer({
                    fromPubkey: payer.publicKey,
                    toPubkey: jitoFeeWallet,
                    lamports: priorityFee,
                }),
            ],
        }).compileToV0Message();
        const jitoFeeTx = new VersionedTransaction(jitTipTxFeeMessage);
        jitoFeeTx.sign([payer]);
        const jitoTxsignature = bs58.encode(jitoFeeTx.signatures[0]);
        const serializedJitoFeeTx = bs58.encode(jitoFeeTx.serialize());
        const serializedTransactions = [
            serializedJitoFeeTx,
            ...txs.map((tx) => bs58.encode(tx.serialize())),
        ];
        const sigrequired = [jitoFeeTx, ...txs].map((tx) => {
            const requiredSigners = tx.message.staticAccountKeys
                .filter((_, index) => tx.message.isAccountSigner(index))
                .map((pubkey) => pubkey.toBase58());
            const providedSignatures = tx.message.staticAccountKeys
                .filter((_, index) => tx.message.isAccountSigner(index))
                .map((pubkey, index) => ({
                pubkey: pubkey.toBase58(),
                signature: tx.signatures[index] ? bs58.encode(tx.signatures[index]) : null,
            }));
            // Find missing signatures
            const missingSignatures = requiredSigners.filter((required, index) => { var _a; return tx.signatures[index] === null || ((_a = tx.signatures[index]) === null || _a === void 0 ? void 0 : _a.every((byte) => byte === 0)); });
            return {
                requiredSigners,
                providedSignatures,
                missingSignatures,
            };
        });
        console.log('siggssss', JSON.stringify(sigrequired, null, 2));
        const endpoints = [
            'https://mainnet.block-engine.jito.wtf/api/v1/bundles',
            'https://amsterdam.mainnet.block-engine.jito.wtf/api/v1/bundles',
            'https://frankfurt.mainnet.block-engine.jito.wtf/api/v1/bundles',
            'https://ny.mainnet.block-engine.jito.wtf/api/v1/bundles',
            'https://tokyo.mainnet.block-engine.jito.wtf/api/v1/bundles',
        ];
        const requests = endpoints.map(async (url) => {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    jsonrpc: '2.0',
                    id: 1,
                    method: 'sendBundle',
                    params: [serializedTransactions],
                }),
                signal: abortSignal,
            });
            if (!response.ok) {
                const json = await response.json();
                console.log('executing order not okay response for url', url, json);
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        });
        console.log('Executing Order SOLANA sending jito bundle');
        const results = await Promise.all(requests.map((p) => p.catch((e) => e)));
        console.log('Executing Order SOLANA jitoresults', { results });
        const bundleId = (_a = results === null || results === void 0 ? void 0 : results.find((result) => result === null || result === void 0 ? void 0 : result.result)) === null || _a === void 0 ? void 0 : _a.result;
        // if (!bundleId) {
        //   throw new Error('No bundleId found');
        // }
        // const bundleStatus = await checkJitoBundleStatus(bundleId);
        // if (bundleStatus === 'Failed') {
        //   throw new Error(`Jito bundle failed: ${bundleId}`);
        // }
        const successfulResults = results
            .filter((result) => result !== null)
            .filter((result) => !(result instanceof Error));
        if (successfulResults.length > 0) {
            // const confirmation = await connection.confirmTransaction(
            //   {
            //     signature: jitoTxsignature,
            //     blockhash: latestBlockhash.blockhash,
            //     lastValidBlockHeight: latestBlockhash.lastValidBlockHeight,
            //   },
            //   'confirmed'
            // );
            // if (confirmation.value.err)
            //   return {
            //     success: 0,
            //     error: confirmation?.value?.err,
            //   };
            txs.map((tx) => console.log(`TX Confirmed: https://solscan.io/tx/${bs58.encode(tx.signatures[0])}`));
            return {
                success: 1,
                bundleId,
                signatures: txs.map((tx) => bs58.encode(tx.signatures[0])),
                links: txs.map((tx) => `https://solscan.io/tx/${bs58.encode(tx.signatures[0])}`),
            };
        }
        else {
            console.log(`No successful responses received for jito`);
        }
        return {
            success: 0,
            error: 'No successful responses received for jito',
        };
    }
    catch (error) {
        console.log('Executing Order SOLANA  JITO Error during transaction execution', error);
        return {
            success: 0,
            error,
        };
    }
};
export async function checkJitoBundleStatus(bundleId) {
    var _a, _b;
    const maxTime = 60 * 1000;
    const startTime = Date.now();
    let elapsedTime = 0;
    while (elapsedTime < maxTime) {
        try {
            const body = {
                jsonrpc: '2.0',
                id: 1,
                method: 'getInflightBundleStatuses',
                params: [[bundleId]],
            };
            const resp = await fetch('https://mainnet.block-engine.jito.wtf/api/v1/bundles', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });
            if (!resp.ok) {
                throw new Error(`HTTP error! status: ${resp.status}`);
            }
            const data = await resp.json();
            console.log('Executing order Jito bundle status:', data);
            if (data.error) {
                throw new Error(`API error: ${data.error.message}`);
            }
            const bundleStatus = (_b = (_a = data.result) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b[0];
            if (!bundleStatus) {
                console.log('Bundle not found or invalid response');
                await new Promise((resolve) => setTimeout(resolve, 500));
                elapsedTime = Date.now() - startTime;
                continue;
            }
            if (bundleStatus.status === 'Failed' || bundleStatus.status === 'Landed') {
                return bundleStatus.status;
            }
            await new Promise((resolve) => setTimeout(resolve, 500));
            elapsedTime = Date.now() - startTime;
        }
        catch (error) {
            console.error('Error checking bundle status:', error);
            await new Promise((resolve) => setTimeout(resolve, 500));
            elapsedTime = Date.now() - startTime;
        }
    }
    throw new Error(`Timeout: Bundle ${bundleId} status not resolved after ${maxTime}ms`);
}
